module.exports = __webpack_public_path__ + "static/spotorganicmuslin-457751eee5479c8b77707112d628759c.jpeg";